export const FREE_GIFT = 'FREE_GIFT';
export const DONATE_ITEM = 'DONATE_ITEM';
export const SAVE = 'SAVE';
export const REMOVE = 'REMOVE';